import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { Button, theme } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../../store/stores.js";
import { __, _i } from "../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../utils/matomoMask.js";
// Confirmation card shown after a magic-link email has been sent. Sits in
// the same auth-card chrome as the sign-in form so the idle → confirmation
// transition is a content-swap, not a layout-swap.
const MagicLinkConfirmation = observer(({ email })=>{
    const { token } = theme.useToken();
    const { accountV2Store } = useStores();
    return /*#__PURE__*/ _jsx("div", {
        className: "rc-account-v2-auth-card-wrap",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-auth-card",
            style: {
                background: token.colorBgContainer,
                borderColor: token.colorBorder
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-auth-card__icon rc-account-v2-auth-card__icon--lg",
                    style: {
                        color: token.colorSuccess
                    },
                    children: /*#__PURE__*/ _jsx(CheckCircleFilled, {})
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "rc-account-v2-auth-card__title",
                    style: {
                        color: token.colorTextHeading
                    },
                    children: __("Magic link on the way")
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "rc-account-v2-auth-card__subtitle",
                    style: {
                        color: token.colorTextSecondary
                    },
                    children: _i(__("Open the email we just sent to {{strong}}%s{{/strong}} to sign in.", email), {
                        strong: /*#__PURE__*/ _jsx("strong", {
                            ...MATOMO_MASK
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-auth-card__cross-links rc-account-v2-auth-card__cross-links--centered",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "link",
                        onClick: ()=>accountV2Store.resetSubmitted(),
                        children: __("Sign-in with a different address")
                    })
                })
            ]
        })
    });
});
export { MagicLinkConfirmation };
